import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconChevronDown = /*@__PURE__*/ proxyCustomElement(class CosmosIconChevronDown extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '18f99f927c6fa29107ca7f1935dd1031715f5e6d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7928323f9b2e69bbb1339af1d134514a8227ce47', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'c0e22844665cc638f2ad21b0d8e7cf216eccacac', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m11.36 15.18 5.82-5.83a.48.48 0 0 0 0-.7l-.35-.36a.51.51 0 0 0-.71 0L11 13.41 5.89 8.29a.51.51 0 0 0-.71 0l-.35.36a.48.48 0 0 0 0 .7l5.82 5.83a.51.51 0 0 0 .71 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-chevron-down", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-chevron-down"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-chevron-down":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconChevronDown);
            }
            break;
    } });
}

export { CosmosIconChevronDown as C, defineCustomElement as d };
